import { render, staticRenderFns } from "./WebSubmitNote.vue?vue&type=template&id=6b645151&scoped=true&"
import script from "./WebSubmitNote.vue?vue&type=script&lang=ts&"
export * from "./WebSubmitNote.vue?vue&type=script&lang=ts&"
import style0 from "./WebSubmitNote.vue?vue&type=style&index=0&id=6b645151&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b645151",
  null
  
)

export default component.exports